import ROUTES from "./seo-routes.json";

export const SITE_ORIGIN = process.env.REACT_APP_SITE_ORIGIN;
const SOCIAL_IMAGE = `${SITE_ORIGIN}/assets/wstf-social.png`;
const [, DEFAULT_DESC] = ROUTES.default;

const PRIVATE = /^\/(admin|dashboard|settings|club-builder|dev|login|register)(\/|$)|^\/match\/[^/]+\/(play|control)$/;

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
  el.setAttribute("content", content);
}

function canonicalFor(pathname, search) {
  let p = pathname.replace(/^\/player\//, "/players/");
  if (p.length > 1) p = p.replace(/\/+$/, "");
  let qs = "";
  if (p === "/rankings") {
    const sp = new URLSearchParams(search);
    const keep = new URLSearchParams();
    ["entity", "ranking"].forEach((k) => sp.get(k) && keep.set(k, sp.get(k)));
    qs = keep.toString() ? `?${keep}` : "";
  }
  return `${SITE_ORIGIN}${p}${qs}`;
}

export function resolveMeta(pathname) {
  const p = pathname.length > 1 ? pathname.replace(/\/+$/, "") : pathname;
  if (ROUTES.pages[p]) return ROUTES.pages[p];
  const hit = ROUTES.prefix.find(([pre]) => p.startsWith(pre));
  return hit ? [hit[1], hit[2]] : ROUTES.default;
}

export function applyRouteMeta(pathname, search) {
  const [title, desc] = resolveMeta(pathname);
  const url = canonicalFor(pathname, search);
  document.title = title;
  setMeta("name", "description", desc);
  setMeta("name", "robots", PRIVATE.test(pathname) ? "noindex, nofollow" : "index, follow");
  setMeta("property", "og:title", title);
  setMeta("property", "og:description", desc);
  setMeta("property", "og:url", url);
  setMeta("property", "og:image", SOCIAL_IMAGE);
  setMeta("name", "twitter:title", title);
  setMeta("name", "twitter:description", desc);
  setMeta("name", "twitter:image", SOCIAL_IMAGE);
  let link = document.head.querySelector('link[rel="canonical"]');
  if (!link) { link = document.createElement("link"); link.setAttribute("rel", "canonical"); document.head.appendChild(link); }
  link.setAttribute("href", url);
}
